import { Component } from 'preact'
import { Router } from 'preact-router'
import Header from './header'
import GlobalFooter from './footer/GlobalFooter'
import styled from 'styled-components'

// Code-splitting is automated for routes
import Landing from '../routes/landing'
import RetailerListing from '../routes/retailerListing'
import RetailerOfferListing from '../routes/retailerOfferListing'
import Error from '../routes/error'
import TermsAndConditions from '../routes/termsConditions'
import TourismOffers from '../routes/tourismListing'
import TourismOfferListing from '../routes/tourismOfferListing'
import Fonts from './Fonts';

import { connect } from 'preact-redux'
import { fetchContent } from '../actions'
import LoadingIcon from './elements/Loading';
import PrivacyPolicy from '../routes/privacyPolicy';


const Content = styled.div`
	min-height: 100%;
`
const Wrapper = styled.div`
	height: 100%;
	margin: 0;
`
const ContentInside = styled.div`
	padding: 75px 0;
`

class App extends Component {

	componentDidMount() {
		this.props.fetchContent()
	}

	render() {
		if (this.props.loading) {
			return <LoadingIcon />
		}

		if (this.props.error) {
			return <Error />
		}

		return (
			<Wrapper>
				<Fonts fonts={this.props.theme.fonts} />
				<Header />
				<Content>
					<ContentInside>
						<Router>
							<Landing path="/" />
							<Error path="/error" />
							<TermsAndConditions path="/terms-and-conditions" />
							<PrivacyPolicy path="/privacy-policy" />
							<TourismOffers path="/tourism-partners" />
							<TourismOfferListing path="/tourism-partners/:partner" />
							<RetailerListing path="/:category" />
							<RetailerOfferListing path="/:category/:retailer" />
						</Router>
					</ContentInside>
				</Content>
				<GlobalFooter />
			</Wrapper>
		)
	}
}

const mapStateToProps = ({ loading, error, theme }) => {
	return { loading, error, theme }
}

const mapDispatchToProps = (dispatch) => ({
	fetchContent: () => dispatch(fetchContent())
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(App)





// WEBPACK FOOTER //
// ./components/app.js